import { Calculator, FileText, Send } from 'lucide-react';
import { AutomationTemplate } from '../types/automation.types';

export const AUTOMATION_TEMPLATES: AutomationTemplate[] = [
  {
    id: 'generate-bulletin',
    nameKey: 'automation.templates.generateBulletin.name',
    descriptionKey: 'automation.templates.generateBulletin.description',
    icon: FileText,
    requiredFields: [
      'email',
      'dayOfMonth',
      'notificationEmail',
      'executionHour',
      'executionMinute',
      'retryHour',
      'retryMinute',
    ],
  },
  {
    id: 'calculate-dsn',
    nameKey: 'automation.templates.calculateDsn.name',
    descriptionKey: 'automation.templates.calculateDsn.description',
    icon: Calculator,
    requiredFields: [
      'dayOfMonth',
      'notificationEmail',
      'executionHour',
      'executionMinute',
      'retryHour',
      'retryMinute',
    ],
  },
  {
    id: 'generate-edition',
    nameKey: 'automation.templates.generateEdition.name',
    descriptionKey: 'automation.templates.generateEdition.description',
    icon: FileText,
    // Common planning + alerts fields
    // Edition-specific fields are validated in code (option + period)
    requiredFields: [
      'dayOfMonth',
      'notificationEmail',
      'executionHour',
      'executionMinute',
      'retryHour',
      'retryMinute',
    ],
  },
  {
    // La demande de variables au client (décision Rose des 19 et 21/09/2026) :
    // au jour réglé, le client reçoit un mail au nom du cabinet avec le lien
    // de saisie du mois. `email` = l'adresse du client (par défaut celle du
    // dossier) ; les alertes vont, comme partout, à `notificationEmail`.
    id: 'demande-variables',
    nameKey: 'automation.templates.demande-variables.name',
    descriptionKey: 'automation.templates.demande-variables.description',
    icon: Send,
    requiredFields: [
      'dayOfMonth',
      'notificationEmail',
      'executionHour',
      'executionMinute',
      'retryHour',
      'retryMinute',
    ],
  },
];

// Map template IDs to display names for history
export const TEMPLATE_DISPLAY_NAMES: Record<string, string> = {
  'generate-bulletin': 'Générer les bulletins',
  'calculate-dsn': 'Calculer DSN',
  'generate-edition': 'Génération d’édition',
  'demande-variables': 'Demande de variables',
  // Type retiré de l'écran le 10/09/2026 (jamais traité par l'API) ; libellé
  // conservé pour afficher proprement les lignes historiques.
  'custom-contact': 'Demande personnalisée',
  'calculate-bulletin': 'Calculer bulletin', // Legacy mapping
};

// Get template display name with fallback
export const getTemplateDisplayName = (templateId: string): string => {
  return TEMPLATE_DISPLAY_NAMES[templateId] || templateId;
};
